import React from 'react';

import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';
import classnames from 'classnames';

function IconComponent({ icon, className, ...props }: FontAwesomeIconProps) {
  return (
    <FontAwesomeIcon
      className={classnames('Icon', className)}
      icon={icon}
      {...props}
    />
  );
}

const Icon = styled(IconComponent)<FontAwesomeIconProps>``;

export default Icon;
